import type { ColDef } from '@ag-grid-community/core';

import IRPContactsCountCell from './IRPContactsCountCell.vue';
import IRPDataSourceCell from './IRPDataSourceCell.vue';
import IRPOpenOpportunitiesCell from './IRPOpenOpportunitiesCell.vue';
import IRPOpenOpportunitiesHeader from './IRPOpenOpportunitiesHeader.vue';
import IRPOwnerCell from './IRPOwnerCell.vue';
import IRPPartnerCell from './IRPPartnerCell.vue';
import IRPPartnerScoreCell from './IRPPartnerScoreCell.vue';
import IRPPopulationsCell from './IRPPopulationsCell.vue';

export function useRecommendedPartnersColumnDefinitions(): ColDef[] {
  return [
    {
      field: 'partner_name',
      headerName: 'Partner',
      cellRenderer: IRPPartnerCell,
      flex: 3,
      minWidth: 180,
    },
    {
      field: 'partner_score_bucket',
      headerName: 'Partner Score',
      cellRenderer: IRPPartnerScoreCell,
      flex: 1,
      minWidth: 120,
    },
    {
      field: 'account_owners',
      headerName: 'Partner Account Owner',
      cellRenderer: IRPOwnerCell,
      flex: 2,
      minWidth: 130,
    },
    {
      field: 'contacts',
      headerName: 'Contacts',
      cellRenderer: IRPContactsCountCell,
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'opportunities',
      headerName: 'Open Opportunities',
      headerComponent: IRPOpenOpportunitiesHeader,
      cellRenderer: IRPOpenOpportunitiesCell,
      flex: 1,
      minWidth: 110,
    },
    {
      field: 'partner_population_ids',
      headerName: 'Populations',
      cellRenderer: IRPPopulationsCell,
      flex: 1,
      minWidth: 130,
    },
    {
      field: 'data_sources',
      headerName: 'Data Source',
      cellRenderer: IRPDataSourceCell,
      flex: 1,
      minWidth: 110,
    },
  ];
}
